__turbopack_context__.v({
  "arrow": "select-module-scss-module__I6kxHG__arrow",
  "arrowOpen": "select-module-scss-module__I6kxHG__arrowOpen",
  "dropdown": "select-module-scss-module__I6kxHG__dropdown",
  "dropdownButton": "select-module-scss-module__I6kxHG__dropdownButton",
  "dropdownItem": "select-module-scss-module__I6kxHG__dropdownItem",
  "dropdownMenu": "select-module-scss-module__I6kxHG__dropdownMenu",
  "selected": "select-module-scss-module__I6kxHG__selected",
});
